/* Rideau Rempart, le guide en livre, version téléphone et tablette (< 900 px).
   Les 7 pages du livre sont redécoupées en pages qui tiennent chacune sur un écran : la hauteur d'une page
   est calculée d'après l'écran (sous l'en-tête fixe), puis le contenu y est réparti bloc par bloc ; un
   paragraphe trop long continue sur la page suivante. On tourne du doigt ou avec les boutons.
   Au-dessus de 900 px, rr-flipbook.js prend le relais (double page). */
(function () {
  'use strict';
  var book = document.querySelector('.rrg__book');
  if (!book || book.dataset.rrmb || !window.matchMedia) return;
  var leaves = [].slice.call(book.querySelectorAll('.rrg__leaf'));
  var radios = [].slice.call(book.querySelectorAll('.rrg__radio'));
  var stack = book.querySelector('.rrg__stack');
  if (leaves.length < 2 || !stack) return;
  book.dataset.rrmb = '1';

  var mq = window.matchMedia('(max-width: 899px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MIN_H = 300, MAX_H = 760, GAP = 8;
  var SVG = function (n) { return '<svg class="rr-glyph" viewBox="0 0 24 24" aria-hidden="true" focusable="false" style="overflow:visible"><text class="material-symbols-outlined notranslate" translate="no" x="12" y="12" text-anchor="middle" dominant-baseline="central" style="font-size:24px;fill:currentColor;stroke:none">' + n + '</text></svg>'; };
  var ICON_PREV = SVG('arrow_back');
  var ICON_NEXT = SVG('arrow_forward');
  var ICON_BACK = SVG('replay');

  /* ---------- 1. Le contenu : pour chaque page du livre, une suite de blocs ---------- */
  function clean(node) {
    var c = node.cloneNode(true);
    [].forEach.call(c.querySelectorAll('[aria-labelledby]'), function (el) {
      var txt = el.getAttribute('aria-labelledby').split(/\s+/).map(function (id) {
        var t = document.getElementById(id);
        return t ? t.textContent.trim() : '';
      }).filter(Boolean).join('. ');
      el.removeAttribute('aria-labelledby');
      if (txt) el.setAttribute('aria-label', txt);
    });
    [].forEach.call(c.querySelectorAll('[id]'), function (el) { el.removeAttribute('id'); });
    c.removeAttribute('id');
    return c;
  }

  var topics = leaves.map(function (leaf) {
    var sp = leaf.querySelector('.rrg__spread');
    var kids = sp ? [].slice.call(sp.children) : [];
    var fig = null, text = null;
    kids.forEach(function (k) {
      if (!fig && k.tagName === 'FIGURE') fig = k;
      else if (!text) text = k;
    });
    text = text || leaf;
    var no = text.querySelector('.rrg__leafno');
    var label = no ? no.textContent.split('·').slice(1).join('·').trim() : '';
    if (!label) {
      var al = leaf.getAttribute('aria-label') || '';
      label = al.indexOf(':') > -1 ? al.split(':').slice(1).join(':').trim() : al;
    }
    var blocks = [];
    if (fig) blocks.push({ kind: 'fig', src: fig });
    var firstP = true;
    [].forEach.call(text.children, function (el) {
      var cl = el.classList;
      if (cl.contains('rrg__leafhead') || cl.contains('rrg__turns')) return;
      var kind = 'blk';
      if (/^H[1-6]$/.test(el.tagName)) kind = 'head';
      else if (el.tagName === 'P' && !cl.contains('rrg__scene')) kind = 'p';
      else if (cl.contains('rrg__end')) kind = 'end';
      var b = { kind: kind, src: el, first: false };
      if (el.tagName === 'P' && firstP) { b.first = true; firstP = false; }
      blocks.push(b);
    });
    // sur téléphone, chaque partie s'ouvre sur son titre, puis son schéma
    for (var h = 1; h < blocks.length; h++) {
      if (blocks[h].kind === 'head') { if (blocks[0].kind === 'fig') blocks.unshift(blocks.splice(h, 1)[0]); break; }
    }
    return { label: label, blocks: blocks };
  });
  if (!topics.some(function (t) { return t.blocks.length; })) return;

  function prep(b) {
    var n = clean(b.src);
    if (b.first) n.classList.add('rrmb-first');
    return n;
  }

  /* ---------- 2. La structure ---------- */
  var root = document.createElement('div');
  root.className = 'rrmb';
  root.innerHTML =
    '<div class="rrmb__top" aria-hidden="true"><span class="rrmb__topic"></span><span class="rrmb__count"></span></div>' +
    '<div class="rrmb__prog" role="group" aria-label="Aller à une partie du livre"></div>' +
    '<div class="rrmb__view"></div>' +
    '<div class="rrmb__bar">' +
      '<button type="button" class="rrmb__btn rrmb__btn--prev" aria-label="Page précédente">' + ICON_PREV + '</button>' +
      '<button type="button" class="rrmb__btn rrmb__btn--next"></button>' +
    '</div>' +
    '<p class="rrg__sr" aria-live="polite"></p>';
  stack.parentNode.insertBefore(root, stack.nextSibling);
  var view = root.querySelector('.rrmb__view');
  var topicEl = root.querySelector('.rrmb__topic');
  var countEl = root.querySelector('.rrmb__count');
  var prog = root.querySelector('.rrmb__prog');
  var btnPrev = root.querySelector('.rrmb__btn--prev');
  var btnNext = root.querySelector('.rrmb__btn--next');
  var live = root.querySelector('[aria-live]');

  var pages = [], cur = 0, lastW = 0, lastH = 0, sig = '';

  var segs = topics.map(function (tp, i) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'rrmb__seg';
    b.setAttribute('aria-label', 'Partie ' + (i + 1) + ' sur ' + topics.length + ' : ' + tp.label);
    b.innerHTML = '<i></i>';
    b.addEventListener('click', function () {
      var k = firstPageOf(i);
      if (k > -1 && k !== cur) turnTo(k);
    });
    prog.appendChild(b);
    return b;
  });

  function makePage() {
    var el = document.createElement('div');
    el.className = 'rrmb__page';
    el.innerHTML = '<div class="rrmb__in"><div class="rrmb__body"></div></div><span class="rrmb__shade" aria-hidden="true"></span>';
    return el;
  }

  /* ---------- 3. La hauteur d'une page : l'écran, moins l'en-tête fixe et les commandes ---------- */
  function headerBottom() {
    var h = 0;
    [].forEach.call(document.querySelectorAll('.section-header, .shopify-section-group-header-group, header'), function (el) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      var top = parseFloat(cs.top);
      if (isNaN(top) || top > 20) return;
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.height < window.innerHeight / 3) h = Math.max(h, top + r.height);
    });
    return Math.round(h);
  }
  function screenH() {
    // la plus petite hauteur visible (barres du navigateur affichées) : elle ne bouge pas quand elles se replient
    var pr = document.createElement('div');
    pr.style.cssText = 'position:fixed;left:0;top:0;width:0;height:100vh;height:100svh;visibility:hidden;pointer-events:none';
    document.body.appendChild(pr);
    var h = pr.getBoundingClientRect().height;
    document.body.removeChild(pr);
    var ih = window.innerHeight || h;
    return Math.round(h > 0 ? Math.min(h, ih) : ih);
  }
  function targetH() {
    var chrome = root.offsetHeight - view.offsetHeight;
    var h = screenH() - headerBottom() - chrome - GAP * 2;
    return Math.max(MIN_H, Math.min(MAX_H, Math.floor(h)));
  }

  /* ---------- 4. La mise en pages ---------- */
  function paginate(H) {
    view.style.height = H + 'px';
    root.style.setProperty('--mb-h', H + 'px');
    var probe = makePage();
    probe.classList.add('is-probe');
    view.appendChild(probe);
    var body = probe.querySelector('.rrmb__body');
    var lineH = parseFloat(getComputedStyle(body).fontSize) * 1.6 || 27;
    var out = [];

    function fits() { return body.scrollHeight <= body.clientHeight + 1; }
    function used() {
      var last = body.lastElementChild;
      if (!last) return 0;
      return last.getBoundingClientRect().bottom - body.getBoundingClientRect().top + (parseFloat(getComputedStyle(last).marginBottom) || 0);
    }
    function points(p, words) {
      var pts = [], walker = document.createTreeWalker(p, NodeFilter.SHOW_TEXT, null), n, m;
      var re = words ? /\s+/g : /[.!?…][»”’)]?\s+/g;
      while ((n = walker.nextNode())) {
        re.lastIndex = 0;
        while ((m = re.exec(n.data))) pts.push({ node: n, off: m.index + m[0].length });
      }
      return pts;
    }
    function cut(p, pt) {
      var r1 = document.createRange(), r2 = document.createRange();
      r1.setStart(p, 0); r1.setEnd(pt.node, pt.off);
      r2.setStart(pt.node, pt.off); r2.setEnd(p, p.childNodes.length);
      var a = p.cloneNode(false), b = p.cloneNode(false);
      a.appendChild(r1.cloneContents());
      b.appendChild(r2.cloneContents());
      b.classList.add('rrmb-cont');
      return [a, b];
    }
    // coupe un paragraphe entre deux phrases (ou entre deux mots si la page est vide) pour remplir la page
    function split(p, empty) {
      if (!empty && body.clientHeight - used() < 3 * lineH) return null;
      for (var pass = 0; pass < 2; pass++) {
        if (pass === 1 && !empty) break;
        var pts = points(p, pass === 1);
        for (var k = pts.length - 1; k >= 0; k--) {
          var parts = cut(p, pts[k]);
          if (!parts[1].textContent.trim() || !parts[0].textContent.trim()) continue;
          body.appendChild(parts[0]);
          var ok = fits() && (empty || parts[0].getBoundingClientRect().height >= 2 * lineH - 2);
          body.removeChild(parts[0]);
          if (ok) return parts;
        }
      }
      return null;
    }
    // un schéma trop haut pour la page : on le réduit un peu (jamais sous 70 % de sa taille)
    function fitFig(fig) {
      var svg = fig.querySelector('svg');
      if (!svg) return false;
      body.appendChild(fig);
      var over = body.scrollHeight - body.clientHeight;
      var h = svg.getBoundingClientRect().height;
      var target = Math.floor(h - over - 2);
      var ok = target >= Math.max(130, h * 0.7);
      if (ok) svg.style.maxHeight = target + 'px';
      body.removeChild(fig);
      return ok;
    }
    // sinon on coupe la figure : entre deux lignes d'une liste, ou avant la légende
    function figUnits(fig) {
      var units = [];
      [].forEach.call(fig.children, function (c) {
        if ((c.tagName === 'UL' || c.tagName === 'OL') && c.children.length > 1) {
          [].forEach.call(c.children, function (li) { units.push({ list: c, el: li }); });
        } else units.push({ el: c });
      });
      return units;
    }
    function buildFig(fig, units) {
      var f = fig.cloneNode(false), lastList = null, lc = null;
      units.forEach(function (u) {
        if (u.list) {
          if (u.list !== lastList) { lc = u.list.cloneNode(false); f.appendChild(lc); lastList = u.list; }
          lc.appendChild(u.el.cloneNode(true));
        } else {
          lastList = null;
          f.appendChild(u.el.cloneNode(true));
        }
      });
      return f;
    }
    function splitFig(fig) {
      var units = figUnits(fig);
      for (var k = units.length - 1; k >= 1; k--) {
        var a = buildFig(fig, units.slice(0, k));
        body.appendChild(a);
        var ok = fits();
        body.removeChild(a);
        if (ok) {
          var b = buildFig(fig, units.slice(k));
          b.classList.add('rrmb-cont');
          return [a, b];
        }
      }
      return null;
    }

    topics.forEach(function (tp, ti) {
      var q = tp.blocks.map(function (b, bi) { return { b: b, bi: bi, node: prep(b) }; });
      var items = [];
      body.innerHTML = '';
      function flush() {
        if (!items.length) return;
        out.push({
          topic: ti,
          items: items,
          plate: items.length === 1 && items[0].b.kind === 'fig',
          over: body.scrollHeight > body.clientHeight + 1
        });
        items = [];
        body.innerHTML = '';
      }
      var i = 0;
      while (i < q.length) {
        var it = q[i];
        body.appendChild(it.node);
        var ok = fits();
        if (ok && it.b.kind === 'head' && items.length && q[i + 1]) {
          // un titre ne reste jamais seul en bas de page : il part avec ce qui le suit
          var nx = q[i + 1];
          body.appendChild(nx.node);
          ok = fits();
          body.removeChild(nx.node);
          if (!ok && nx.b.kind === 'p') ok = !!split(nx.node, false);
        }
        if (ok) { items.push(it); i++; continue; }
        body.removeChild(it.node);
        if (it.b.kind === 'end' && items.length > 1) {
          // les boutons de fin restent avec le paragraphe qui les précède
          var back = items.pop();
          body.removeChild(back.node);
          q.splice(i, 0, back);
          flush();
          continue;
        }
        // dernier paragraphe d'une partie : le couper ne ferait pas gagner de page, on le garde entier
        var keepWhole = false;
        if (it.b.kind === 'p' && items.length && i === q.length - 1) {
          body.appendChild(it.node);
          keepWhole = it.node.getBoundingClientRect().height <= body.clientHeight;
          body.removeChild(it.node);
        }
        if (it.b.kind === 'p' && !keepWhole) {
          var parts = split(it.node, !items.length);
          if (parts) {
            body.appendChild(parts[0]);
            items.push({ b: it.b, bi: it.bi, node: parts[0] });
            q.splice(i, 1, { b: it.b, bi: it.bi, node: parts[0] }, { b: it.b, bi: it.bi, node: parts[1] });
            i++;
            flush();
            continue;
          }
        }
        if (it.b.kind === 'fig' && (!items.length || (items.length === 1 && items[0].b.kind === 'head'))) {
          // la figure reste avec son titre : on réduit un peu le schéma, sinon on coupe la figure
          if (fitFig(it.node)) { body.appendChild(it.node); items.push(it); i++; continue; }
          var fp = splitFig(it.node);
          if (fp) {
            body.appendChild(fp[0]);
            items.push({ b: it.b, bi: it.bi, node: fp[0] });
            q.splice(i, 1, { b: it.b, bi: it.bi, node: fp[0] }, { b: it.b, bi: it.bi, node: fp[1] });
            i++;
            flush();
            continue;
          }
          if (items.length) {
            // titre + schéma impossibles sur un si petit écran : le titre passe après le schéma
            var hd = items.pop();
            body.removeChild(hd.node);
            q.splice(i + 1, 0, hd);
            continue;
          }
        }
        if (items.length) { flush(); continue; }
        // dernier recours : la page défilera à l'intérieur plutôt que de couper du contenu
        body.appendChild(it.node);
        items.push(it);
        i++;
      }
      flush();
    });
    view.removeChild(probe);
    return out;
  }

  function render(list) {
    [].slice.call(view.querySelectorAll('.rrmb__page')).forEach(function (el) { view.removeChild(el); });
    pages = list.map(function (pg, i) {
      var el = makePage();
      var body = el.querySelector('.rrmb__body');
      pg.items.forEach(function (it) { body.appendChild(it.node); });
      if (pg.plate) el.classList.add('rrmb__page--plate');
      if (pg.over) el.classList.add('rrmb__page--over');
      el.setAttribute('role', 'group');
      el.setAttribute('aria-roledescription', 'page');
      el.setAttribute('aria-label', 'Page ' + (i + 1) + ' sur ' + list.length + ' : ' + topics[pg.topic].label);
      view.appendChild(el);
      pg.el = el;
      pg.shade = el.querySelector('.rrmb__shade');
      pg.first = pg.items[0].bi;
      return pg;
    });
  }

  function firstPageOf(t) { for (var i = 0; i < pages.length; i++) if (pages[i].topic === t) return i; return -1; }
  function lastPageOf(t) { for (var i = pages.length - 1; i >= 0; i--) if (pages[i].topic === t) return i; return -1; }

  function show(i) {
    cur = Math.max(0, Math.min(pages.length - 1, i));
    pages.forEach(function (pg, k) {
      var on = k === cur;
      pg.el.classList.remove('is-under', 'is-turning');
      pg.el.classList.toggle('is-cur', on);
      pg.el.style.transform = '';
      pg.shade.style.opacity = '';
      if (on) { pg.el.removeAttribute('aria-hidden'); pg.el.inert = false; }
      else { pg.el.setAttribute('aria-hidden', 'true'); pg.el.inert = true; }
    });
    var t = pages[cur].topic, last = cur === pages.length - 1;
    topicEl.textContent = topics[t].label;
    countEl.textContent = (cur + 1) + ' / ' + pages.length;
    btnPrev.disabled = cur === 0;
    btnNext.innerHTML = last ? '<span class="rrmb__lbl">Recommencer</span>' + ICON_BACK : '<span class="rrmb__lbl">Tourner la page</span>' + ICON_NEXT;
    btnNext.setAttribute('aria-label', last ? 'Revenir à la première page' : 'Tourner la page');
    btnNext.classList.toggle('is-restart', last);
    segs.forEach(function (s, k) {
      var a = firstPageOf(k), b = lastPageOf(k);
      var p = a < 0 ? 0 : cur > b ? 1 : cur < a ? 0 : (cur - a + 1) / (b - a + 1);
      s.firstChild.style.setProperty('--p', p.toFixed(3));
      if (k === t) s.setAttribute('aria-current', 'step'); else s.removeAttribute('aria-current');
    });
    root.setAttribute('data-left', String(Math.min(2, pages.length - 1 - cur)));
    if (radios[t] && !radios[t].checked) radios[t].checked = true; // garde la double page (ordinateur) au même endroit
  }
  function announce() {
    live.textContent = '';
    var msg = 'Page ' + (cur + 1) + ' sur ' + pages.length + ' : ' + topics[pages[cur].topic].label;
    window.requestAnimationFrame(function () { live.textContent = msg; });
  }

  /* ---------- 5. Tourner la page ---------- */
  var anim = null, raf = 0;
  function prepareTurn(to) {
    if (anim || to === cur || to < 0 || to >= pages.length) return false;
    var dir = to > cur ? 1 : -1;
    anim = { to: to, dir: dir, p: 0, turn: dir > 0 ? pages[cur] : pages[to], under: dir > 0 ? pages[to] : pages[cur] };
    anim.under.el.classList.remove('is-cur');
    anim.turn.el.classList.remove('is-cur');
    anim.under.el.classList.add('is-under');
    anim.turn.el.classList.add('is-turning');
    anim.under.el.inert = true;
    anim.turn.el.inert = true;
    setP(0);
    return true;
  }
  function setP(p) {
    anim.p = p;
    var lift = anim.dir > 0 ? p : 1 - p;           // 0 : page à plat, 1 : page sur la tranche
    anim.turn.el.style.transform = 'rotateY(' + (-90 * lift).toFixed(2) + 'deg)';
    anim.turn.shade.style.opacity = Math.min(1, lift * 1.3).toFixed(3);
    anim.under.shade.style.opacity = (Math.sin(Math.PI * Math.min(1, lift * 0.9 + 0.1)) * 0.9 * (1 - lift * 0.5)).toFixed(3);
  }
  function animateTo(target, dur, done) {
    cancelAnimationFrame(raf);
    var from = anim.p;
    if (REDUCED || dur <= 0) { setP(target); done(); return; }
    var t0 = performance.now();
    var ease = function (t) { return 1 - Math.pow(1 - t, 3); };
    var step = function (now) {
      var k = Math.min(1, (now - t0) / dur);
      setP(from + (target - from) * ease(k));
      if (k < 1) raf = requestAnimationFrame(step); else done();
    };
    raf = requestAnimationFrame(step);
  }
  function endTurn(commit) {
    var to = anim.to;
    anim = null;
    show(commit ? to : cur);
    if (commit) announce();
  }
  function align() {
    // si le livre dépasse de l'écran, on le recale juste sous l'en-tête
    var r = root.getBoundingClientRect(), top = headerBottom() + GAP;
    if (r.top >= top - 4 && r.bottom <= window.innerHeight + 4) return;
    var y = (window.pageYOffset || document.documentElement.scrollTop) + r.top - top;
    try { window.scrollTo({ top: Math.max(0, y), behavior: REDUCED ? 'auto' : 'smooth' }); }
    catch (e) { window.scrollTo(0, Math.max(0, y)); }
  }
  function turnTo(to) {
    if (!prepareTurn(to)) return;
    align();
    animateTo(1, 560, function () { endTurn(true); });
  }
  btnNext.addEventListener('click', function () { turnTo(cur === pages.length - 1 ? 0 : cur + 1); });
  btnPrev.addEventListener('click', function () { turnTo(cur - 1); });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight' && cur < pages.length - 1) { e.preventDefault(); turnTo(cur + 1); }
    else if (e.key === 'ArrowLeft' && cur > 0) { e.preventDefault(); turnTo(cur - 1); }
  });

  /* ---------- 6. Au doigt : la page suit le geste, le défilement vertical reste libre ---------- */
  var sx = null, sy = 0, pid = null, dragging = false, moved = false, lastX = 0, lastT = 0, vx = 0;
  view.addEventListener('pointerdown', function (e) {
    if (anim || (e.pointerType === 'mouse' && e.button !== 0)) return;
    sx = e.clientX; sy = e.clientY; pid = e.pointerId;
    dragging = false; moved = false; lastX = sx; lastT = performance.now(); vx = 0;
  });
  view.addEventListener('pointermove', function (e) {
    if (sx === null || e.pointerId !== pid) return;
    var dx = e.clientX - sx, dy = e.clientY - sy;
    if (!dragging) {
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      if (Math.abs(dy) >= Math.abs(dx)) { sx = null; return; }
      if (!prepareTurn(cur + (dx < 0 ? 1 : -1))) { sx = null; return; }
      dragging = true; moved = true;
      root.classList.add('is-dragging');
      try { view.setPointerCapture(pid); } catch (err) { /* rien */ }
    }
    var w = view.clientWidth || 1;
    setP(Math.max(0, Math.min(1, (anim.dir > 0 ? -dx : dx) / (w * 0.8))));
    var now = performance.now();
    vx = (e.clientX - lastX) / Math.max(1, now - lastT);
    lastX = e.clientX; lastT = now;
  });
  function release(e) {
    if (sx === null || (e && e.pointerId !== pid)) return;
    sx = null;
    if (!dragging || !anim) return;
    dragging = false;
    root.classList.remove('is-dragging');
    var flick = anim.dir > 0 ? vx < -0.35 : vx > 0.35;
    var go = e && e.type === 'pointercancel' ? anim.p > 0.5 : (anim.p > 0.3 || flick);
    animateTo(go ? 1 : 0, go ? 320 : 240, function () { endTurn(go); if (go) align(); });
  }
  view.addEventListener('pointerup', release);
  view.addEventListener('pointercancel', release);
  view.addEventListener('lostpointercapture', release);
  // après un glissé, on n'ouvre pas le lien sur lequel le doigt s'est posé
  view.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

  /* ---------- 7. Mise en route, rotation de l'écran, polices ---------- */
  function layout(force) {
    if (!mq.matches || !root.offsetWidth) return;
    var H = targetH(), w = view.clientWidth;
    if (!force && w === lastW && Math.abs(H - lastH) < 24) return;
    if (anim) { cancelAnimationFrame(raf); anim = null; }
    var anchor = pages.length ? { t: pages[cur].topic, b: pages[cur].first } : { t: Math.max(0, radios.findIndex(function (r) { return r.checked; })), b: 0 };
    var list = paginate(H);
    var s = H + ':' + w + ':' + list.map(function (p) { return p.topic + '.' + p.items.length + '.' + p.items[0].bi + '.' + p.items[0].node.textContent.length; }).join('|');
    lastW = w; lastH = H;
    if (s === sig && pages.length) { show(cur); return; }
    sig = s;
    render(list);
    var k = firstPageOf(anchor.t);
    for (var i = k; i > -1 && i < pages.length && pages[i].topic === anchor.t; i++) if (pages[i].first <= anchor.b) k = i;
    show(k < 0 ? 0 : k);
  }
  function setup() {
    if (mq.matches) {
      book.classList.add('rrmb-on');
      layout(true);
    } else {
      book.classList.remove('rrmb-on');
      if (anim) { cancelAnimationFrame(raf); anim = null; if (pages.length) show(cur); }
    }
  }
  setup();
  if (mq.addEventListener) mq.addEventListener('change', setup); else if (mq.addListener) mq.addListener(setup);
  var rt = 0;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { layout(false); }, 200); });
  window.addEventListener('orientationchange', function () { setTimeout(function () { layout(true); }, 400); });
  window.addEventListener('load', function () { layout(true); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { layout(true); });
})();
